module.exports = __webpack_public_path__ + "static/img/heart.eaf5739.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/heart.jpg
// module id = TYGL
// module chunks = 0